import { inject, ref } from 'vue';
import { pageKey, routeKey, setMeta, Meta } from '@drapejs/core';
import { imageResize } from '@distancify/drapejs-storyblok';
import { settingsKey, channelKey } from '@/keys';
import { getChannelConfiguration } from '@/urlUtils';

export default function (middleware: (meta: Meta) => Meta) {
  const route = inject(routeKey, <any>{});
  const page = inject(pageKey, ref());
  const settings = inject(settingsKey, ref());
  const channel = inject(channelKey, ref({}));

  setMeta(() => {
    const title = `${page.value.meta?.title || page.value.name} | Kid's Concept`;
    const description = page.value.meta?.description || null;
    const canonicalUrl = `${route.protocol}//${route.host}${route.pathname?.replace(/\/+$/, '')}`;

    let result = {
      title: title,
      lang: getChannelConfiguration(route)?.language?.substr(0, 2),
      props: {
        'og:title': title,
        'og:description': description,
        'og:url': canonicalUrl,
        'og:image': page.value.metaImage
          ? imageResize(page.value.metaImage, { width: 1200, height: 630 })?.filename
          : null,
        'og:type': 'website',
        description: description,
      },
      links: [
        {
          rel: 'shortcut icon',
          type: 'image/png',
          href: imageResize(settings.value?.favicon, { width: 256, height: 256 })?.filename,
        },
        {
          rel: 'canonical',
          href: canonicalUrl,
        },
      ],
      scripts: []
    };

    const currentChannel = channel.value?.systemId;
    const channelScripts = settings.value?.scripts?.find((s) => s?.channelSelector?.availableChannels?.includes(currentChannel));

    if(channelScripts?.blocks?.length) {
      result.scripts = channelScripts.blocks
        .map((b) => ({ id: b.id, inline: b?.script }))
        .filter((b) => b.inline);
    }

    return middleware ? middleware(result) : result;
  });
}
